export default __webpack_public_path__ + "static/media/greenscreen3.cce2b1f9.jpg";